import { createRouter, createWebHistory } from 'vue-router'
import { ElMessageBox } from 'element-plus'

// 导入useUserStore需要注意在组件外部使用的问题
let userStore = null
const getUserStore = () => {
  if (!userStore) {
    userStore = require('@/store/modules/user').useUserStore()
  }
  return userStore
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/Login.vue'), // 暂时使用登录页面代替
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/wechat-bind-phone',
    name: 'WechatBindPhone',
    component: () => import('@/views/WechatBindPhone.vue'),
    meta: {
      title: '绑定手机号',
      requiresWechatLogin: true // 需要微信登录才能访问
    }
  },
  {
    path: '/wechat-callback',
    name: 'WechatCallback',
    component: () => import('@/views/WechatCallback.vue'),
    meta: {
      title: '微信登录回调'
    }
  },
  {
    path: '/bind-phone',
    name: 'BindPhone',
    component: () => import('@/views/BindPhone.vue'),
    meta: {
      title: '绑定手机号'
    }
  },

  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import('@/views/UserCenter.vue'),
    redirect: '/user-center/info',
    meta: {
      title: '用户中心'
    },
    children: [
      {
        path: 'info',
        name: 'UserInfo',
        component: () => import('@/views/UserInfo.vue'),
        meta: {
          title: '个人信息'
        }
      },
      {
        path: 'security',
        name: 'SecurityCenter',
        component: () => import('@/views/SecurityCenter.vue'),
        meta: {
          title: '安全中心'
        }
      },
      {
        path: 'orders',
        name: 'MyOrders',
        component: () => import('@/views/MyOrders.vue'),
        meta: {
          title: '我的订单'
        }
      },
      {
        path: 'membership',
        name: 'Membership',
        component: () => import('@/views/Membership.vue'),
        meta: {
          title: '会员管理'
        }
      },
      {
        path: 'commission',
        name: 'Commission',
        component: () => import('@/views/Commission.vue'),
        meta: {
          title: '佣金管理'
        }
      },
      {
        path: 'referral',
        name: 'Referral',
        component: () => import('@/views/Referral.vue'),
        meta: {
          title: '推荐管理'
        }
      },
      {
        path: 'coupons',
        name: 'MyCoupons',
        component: () => import('@/views/MyCoupons.vue'),
        meta: {
          title: '我的优惠券'
        }
      }
    ]
  },
  {
    path: '/membership-pricing',
    name: 'MembershipPricing',
    component: () => import('@/views/MembershipPricing.vue'),
    meta: {
      title: '会员定价'
    }
  },
  {    path: '/order-confirm',
    name: 'OrderConfirm',
    component: () => import('@/views/OrderConfirm.vue'),
    meta: {
      title: '订单确认'
    }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import('@/views/Payment.vue'),
    meta: {
      title: '支付页面'
    }
  },
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: () => import('@/views/PaymentResult.vue'),
    meta: {
      title: '支付结果',
      requiresAuth: true
    }
  },

  {
    path: '/product-intro',
    name: 'ProductIntro',
    component: () => import('@/views/ProductIntro.vue'),
    meta: {
      title: '产品介绍'
    }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: {
      title: '产品详情'
    }
  },
  {
    path: '/case-show',
    name: 'CaseShow',
    component: () => import('@/views/CaseShow.vue'),
    meta: {
      title: '案例展示'
    }
  },
  {
    path: '/cases/:id',
    name: 'CaseDetail',
    component: () => import('@/views/CaseDetail.vue'),
    meta: {
      title: '案例详情'
    }
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('@/views/Community.vue'),
    meta: { 
      requiresAuth: true,
      title: '社区'
    }
  },
  // 说明文档页面
  {
    path: '/documentation',
    name: 'Documentation',
    component: () => import('@/views/Documentation.vue'),
    meta: {
      title: '说明文档'
    }
  },
  // 帖子详情页面
  {
    path: '/post/:id',
    name: 'PostDetail',
    component: () => import('@/views/PostDetail.vue'),
    meta: { 
      requiresAuth: true,
      title: '帖子详情'
    }
  },
  {
    path: '/suggestion',
    name: 'Suggestion',
    component: () => import('@/views/Suggestion.vue'),
    meta: { 
      requiresAuth: true,
      title: '意见反馈'
    }
  },

  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/Download.vue'),
    meta: {
      title: '软件下载'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 配置滚动行为，确保每次页面跳转都从顶部开始
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器前进后退），则恢复到该位置
    if (savedPosition) {
      return savedPosition
    }
    
    // 否则，直接跳转到页面顶部（不使用平滑滚动）
    return { top: 0 }
  }
})

// 设置页面标题
const setPageTitle = (to) => {
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - 自动转`
  } else {
    // 对于嵌套路由，尝试获取父路由的title
    const matched = to.matched
    if (matched && matched.length > 0) {
      const routeWithTitle = matched.find(route => route.meta && route.meta.title)
      if (routeWithTitle) {
        document.title = `${routeWithTitle.meta.title} - 自动转`
        return
      }
    }
    document.title = '自动转'
  }
}

// 路由守卫 - 检查用户登录状态
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  setPageTitle(to)
  
  const userStore = getUserStore()
  
  // 如果有token但没有用户信息，则自动获取用户信息
  // 排除登录页面，避免在登录页面时重复调用获取用户信息接口导致无限循环
  if (userStore && userStore.isLoggedIn && (!userStore.userInfo || Object.keys(userStore.userInfo).length === 0) && to.path !== '/login' && to.path !== '/register') {
    try {
      await userStore.fetchUserInfo()
    } catch (error) {
      console.error('获取用户信息失败:', error)
      // 清除token和用户信息
      userStore.clearToken()
      userStore.clearUserInfo()
      // 如果是需要登录的页面，则跳转到登录页
      const requiresAuth = to.path.startsWith('/user-center') || 
                          to.path === '/community' || 
                          to.path === '/suggestion'
      
      if (requiresAuth) {
        ElMessageBox.alert('<i class="iconfont icon-jinggao"></i> 登录状态已过期，请重新登录', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).catch(() => {
        })
        return next('/login')
      }
    }
  }
  
  // 需要登录的路由
  const requiresAuth = to.path.startsWith('/user-center') || 
                     to.path === '/community' || 
                     to.path === '/suggestion'
  
  // 重新检查登录状态
  const isLoggedIn = userStore && userStore.isLoggedIn
  
  if (requiresAuth && !isLoggedIn) {
    ElMessageBox.alert('<i class="iconfont icon-jinggao"></i> 请先登录以访问该页面', '提示', {
      confirmButtonText: '确定',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).catch(() => {
    })
    next('/login')
  } else if ((to.path === '/login' || to.path === '/register') && isLoggedIn) {
    // 已登录用户不能访问登录和注册页
    ElMessageBox.alert('<i class="iconfont icon-tishi"></i> 您已登录，将跳转到首页', '提示', {
      confirmButtonText: '确定',
      type: 'info',
      dangerouslyUseHTMLString: true
    }).catch(() => {
    })
    next('/')
  } else {
    next()
  }
})

export default router
